import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Auth } from '@freelancer/auth';
import { Bid, Datastore } from '@freelancer/datastore';
import * as Rx from 'rxjs';

@Component({
  template: `
    <app-expanded-bid></app-expanded-bid>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandedBidOverlayComponent implements OnInit {
  @Input() bidId: number;

  bid$: Rx.Observable<Bid>;

  constructor(private datastore: Datastore, private auth: Auth) {}

  ngOnInit() {
    this.bid$ = this.datastore.object(
      'bids',
      this.auth.getUserId(),
      this.bidId,
    );
  }
}
